export default {
  age: {
    id: 'profile.age',
    defaultMessage: `{age, plural,
      one {# year}
      other {# years}}
      old`,
  },

  ageDesc: {
    id: 'profile.ageDesc',
    defaultMessage: `Age is calculated based on year of admission to college`,
  },
};
